import { ClickDataPoint } from './click-notifier';
import { HighChartDataBase } from './high-chart-data-base';

export class ColumnHighChartData extends HighChartDataBase {
    private customSubTitle: string = "";

    private setTopDataLabels(): void {
        let that = this;
        this.customSubTitle = this.chartSubTitle + "<br><small style='font-size:10px;'>ɳ = " + this.customDataLabelsTitle + "</small>";
        for (var i = 0; i < this.chartSeries[0].data.length; i++) {
            let item = this.chartSeries[0].data[i];
            item["dataLabels"] = { 
                enabled: true,
                formatter: function() { return that.customDataLabels[that.categories.indexOf(this.point.name)] },
                inside: false,      // Whether to align the data label inside the box
                crop: false,        // Whether to hide data labels that are outside the plot area
                overflow: "none",   // How to handle data labels that flow outside the plot area
                rotation: this.categories.length > 25 ? this.xAxisLabelRotation : 0,
                y: this.categories.length > 25 ? this.xAxisLabelRotation != 0 ? -10 : 0 : 0,
                verticalAlign: 'bottom',
                style: {
                    color: '#666',
                    fontSize: '9px'
                },
            }
            this.chartSeries[0].data[i] = item;
        }
    }

    public getHighChartOptions(): Object {
        let that = this;
        if (this.customDataLabels != null) 
            this.setTopDataLabels();

        let clientwidthIsTabletOrGreater: boolean = document.getElementById("chart-wrapper") && document.getElementById("chart-wrapper").clientWidth > 750;

        let options = {
            accessability: { enabled: false },
            chart: {
                type: 'column',
                height: this.chartHeight,
                zoomType: 'x',
                resetZoomButton: {
                    position: { x: 0, y: -45 }
                },
                panning: true,
                panKey: 'shift'
            },
            title: { 
                text: this.chartTitle,
                widthAdjust: -150,
                margin: 30
            },
            subtitle: { 
                text: this.customSubTitle.length > 0 ? this.customSubTitle : this.chartSubTitle,
                useHTML: true,
                style: { "text-align": "center" },
                widthAdjust: -150
            },
            yAxis: this.getYAxis(),
            series: this.chartSeries,
            xAxis: {
                type: "category",
                categories: this.categories,
                title: { 
                    text: this.xAxisTitle 
                },
                labels: {
                    step: (clientwidthIsTabletOrGreater ? (this.categories.length < 100 ? 1 : null) : null),
                    rotation: this.xAxisLabelRotation,
                    style: {
                        fontSize: this.categories.length > 30 && this.categories.length < 100 ? '10px' : '11px'
                    },
                    formatter: function () {
                        for (var i = 0; i < that.categories.length; i++) {
                            if (that.categories[i] === this.value) {
                                if (that.xAxisColors && that.xAxisColors[i] != '')
                                    return '<span style="fill: ' + that.xAxisColors[i] + ';">' + this.value + '</span>';
                                else 
                                    return this.value;
                            }
                        }
                    }
                },
                min: Number.isNaN(this.xMinValue) ? null : this.xMinValue,
                max: Number.isNaN(this.xMaxValue) ? null : this.xMaxValue
            },
            tooltip: {
                formatter: function() { return that.getDefaultTooltipText(this, true); },                
                shared: true,
                useHTML: true
            },
            plotOptions: {
                column: {
                    borderWidth: 0,
                    pointPadding: 0.2,
                    point: {
                        events: {
                            click: function () {
                                if (that.clickNotifier) {
                                    that.clickNotifier.handleClick(new ClickDataPoint(this.category, this.series.name, this.y));
                                }
                            }
                        }
                    },
                    stacking: this.chartType === 'stacked' ? 'normal' : ''
                }
            },
            colors: this.defaultColors,
            legend: {
                enabled: this.chartSeries.length > 1
            },
            credits: {
                text: this.credits,
                href: this.creditsLink
            },

            responsive: {
                rules: [{
                    condition: {
                        maxWidth: this.chartWidth
                    }
                }]
            },

            exporting: {
                filename: "diagram_" + this.chartTitle
            }
        };

        return options;
    }

    /**
     * Hämta Y-axlar
     */
    private getYAxis() {
        let endOnTick = this.chartType !== 'stacked';
        let tickAmount = this.minIsPositiveMaxIsHundred() ? 5 : null;
        let firstYAxis = this.createYAxis(this.yAxisTitle, this.yAxisTitleColor, this.yMinValue, this.yMaxValue, false, undefined, endOnTick, tickAmount);
        if (!this.hasY2Axis) { 
            //Om det endast finns en y-axis
            return firstYAxis;
        }
        else {
            // Om det finns två y-axlar
            let yAxis = [];
            yAxis.push(firstYAxis);
            let secondYAxis = this.createYAxis(this.y2AxisTitle, this.y2AxisTitleColor, this.y2MinValue, this.y2MaxValue, true, undefined, endOnTick, tickAmount);
            yAxis.push(secondYAxis);
            return yAxis;
        }
    }
}
